var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.email_samples,"headers":_vm.headers,"sort-by":"title","mobile-breakpoint":"0","type":"button"},on:{"click:row":_vm.edit}})
}
var staticRenderFns = []

export { render, staticRenderFns }